import AntdAvatar from 'components/Avatar'
import Flex from 'components/Flex'
import Pagination from 'components/Pagination'
import {
  FlexWrap,
  RowNumberData,
} from 'components/TableStyles/TableContentStyles/TableContentStyles'
import { StyledTable } from 'components/TableStyles/TableStyles'
import TableSearchFilter from 'components/UIComponents/TableSearchFilter'
import CheckCircleIcon from 'components/icons/CheckCircleIcon'
import EmptyCandidateIcon from 'components/icons/EmptyCandidateIcon'
import WarningIcon from 'components/icons/WarningIcon'
import { EmptyWrapper } from 'modules/Drives/Components/Styles/style'
import { SectionWrapper } from 'modules/Roles/ViewRole/Style/style'
import React, { useEffect, useState } from 'react'
import DownloadDrawer from '../DownloadAllDrawer/index'
import ActionDropdown from './ActionDropdown'

const RolesTable = ({
  driveId,
  roleId,
  downloadAsZip,
  setSelectedRows,
  canditateDocumentList,
  getCandidateDocumentsList,
  selectedOption,
  setSelectedCandidates,
  getMatricesList,
}) => {
  let pageLimit = 10
  const [sortBy, setSortBy] = useState('')
  const [orderBy, setOrderBy] = useState('')
  const [searchValue, setSearchValue] = useState('')
  const [candidatesTableData, setCandidatesTableData] = useState({})
  const [pageNum, setPageNum] = useState(0)
  const [count, setCount] = useState(1)
  const [loading, setLoading] = useState(false)
  const [isDownloadDrawerVisible, setIsDownloadDrawerVisible] = useState(false)
  const [urlStudent, setUrlStudent] = useState('')
  const [docDetails, setDocDetails] = useState([])

  const handleSort = (page, search, filter) => {
    if (filter?.order) {
      let sort = filter?.order == 'ascend' ? 'asc' : 'desc'
      setSortBy(filter?.field)
      setOrderBy(sort)
    } else {
      setOrderBy('')
      setSortBy('')
    }
  }

  useEffect(() => {
    getMatricesList({})
  }, [driveId, roleId, searchValue])

  const isCandidateDocAvailable = candidatesTableData?.result?.map(
    row => row?.student?.docRequested
  )
  const docRequestedValues = isCandidateDocAvailable?.includes(true)

  const fetchCandidateData = async () => {
    let { data, status } = await getCandidateDocumentsList({
      driveId: driveId,
      roleId: roleId,
      setLoading,
      searchValue,
      sortby: sortBy,
      orderby: orderBy,
      documentType: selectedOption,
      pageLimit: pageLimit,
      currentPage: pageNum,
    })
    if (status >= 200 && status < 300) {
      setCandidatesTableData(data?.data)
    }
    if (status >= 400) {
      setCandidatesTableData({})
    }
  }

  useEffect(() => {
    setPageNum(0)
    setCount(prev => prev + 1)
  }, [searchValue])

  useEffect(() => {
    let getData
    if (searchValue) {
      getData = setTimeout(() => {
        fetchCandidateData()
      }, 500)
    } else {
      fetchCandidateData()
    }

    return () => clearTimeout(getData)
  }, [sortBy, orderBy, pageNum, count, selectedOption])

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRows(selectedRowKeys)
      setSelectedCandidates(selectedRows)
      if (selectedRows?.length) {
        setSelectedRows(selectedRows?.length === true)
      }
    },
    getCheckboxProps: student => {
      const isScheduled = student?.student?.student_document_map?.length === 0
      return {
        disabled: isScheduled,
      }
    },
  }

  const columns = [
    {
      title: 'Id',
      dataIndex: 'prefixId',
      sorter: true,
      render: (_, { student }) => {
        return student?.docRequested === true ? (
          <RowNumberData>#{student?.prefixId}</RowNumberData>
        ) : null
      },
    },
    {
      title: 'candidate Name',
      dataIndex: 'firstName',
      sorter: true,
      render: (_, { student }) => (
        <RowNumberData>
          {student?.docRequested === true ? student?.firstName : ''}{' '}
          {student?.docRequested === true ? student?.lastName : ''}{' '}
        </RowNumberData>
      ),
    },
    {
      title: 'No.of documents uploaded',
      dataIndex: 'documentsUpload',
      sorter: false,
      render: (_, { student }) => {
        const numericRating = Number(student?.requestedDocsCount)
        const idProofSelected = selectedOption === 'Id'

        return (
          <FlexWrap gap="10px">
            {student?.docRequested === true ? (
              <>
                {numericRating >= 5 ? (
                  <AntdAvatar
                    size={25}
                    IconName={<CheckCircleIcon />}
                    background="none"
                  />
                ) : (
                  <AntdAvatar
                    size={25}
                    IconName={<WarningIcon />}
                    background="none"
                  />
                )}
                <RowNumberData>
                  {idProofSelected
                    ? numericRating === 5
                      ? ' Uploaded'
                      : 'Not Uploaded'
                    : student?.student_document_map?.length}
                </RowNumberData>
              </>
            ) : (
              ''
            )}
          </FlexWrap>
        )
      },
    },
    {
      title: 'Action',
      render: (_, { student }) => {
        if (student?.docRequested === true) {
          return (
            <ActionDropdown
              setIsDownloadDrawerVisible={setIsDownloadDrawerVisible}
              studentUrl={student?.student_document_map[0]?.doc?.url}
              docDetails={student?.student_document_map}
              isDownloadDrawerVisible={isDownloadDrawerVisible}
              setUrlStudent={setUrlStudent}
              setDocDetails={setDocDetails}
              studentUrlink={urlStudent}
              downloadAsZip={downloadAsZip}
              disabled={student?.student_document_map?.length === 0}
            />
          )
        }
        return null
      },
    },
  ]

  const onPageChange = value => {
    setPageNum(value)
  }

  return (
    <>
      <SectionWrapper
        column
        style={{
          border: '1px solid rgb(235, 236, 238)',
          overflowY: 'auto',
          borderRadius: ' 10px',
          marginBottom: '40px',
        }}
      >
        <TableSearchFilter
          currentCount={
            canditateDocumentList?.count < 10
              ? canditateDocumentList?.count
              : canditateDocumentList?.currentPage * 10 -
                10 +
                canditateDocumentList?.list?.length
          }
          searchValue={searchValue}
          setSearchValue={setSearchValue}
          totalCount={10}
          CandidateMenu={{}}
          doc={true}
        />
        <StyledTable
          columns={columns}
          locale={{
            emptyText: (
              <EmptyWrapper column alignCenter isSpin={loading}>
                {!loading && !isCandidateDocAvailable ? (
                  <Flex column alignCenter>
                    <centerText>
                      <EmptyCandidateIcon />
                    </centerText>
                    <centerText>
                      <centerText>No candidate Documentation found</centerText>
                    </centerText>
                  </Flex>
                ) : (
                  <centerText>No candidate Documentation found</centerText>
                )}
              </EmptyWrapper>
            ),
          }}
          pagination={false}
          dataSource={canditateDocumentList?.result}
          rowSelection={docRequestedValues ? rowSelection : null}
          rowKey={'id'}
          onChange={handleSort}
        />
      </SectionWrapper>
      <Pagination
        onChange={onPageChange}
        totalPages={canditateDocumentList?.totalPage}
        pageSize={pageLimit}
        current={pageNum + 1}
      />

      <DownloadDrawer
        setIsDownloadDrawerVisible={setIsDownloadDrawerVisible}
        isDownloadDrawerVisible={isDownloadDrawerVisible}
        studentUrlink={urlStudent}
        setUrlStudent={setUrlStudent}
        docDetails={docDetails}
        downloadAsZip={downloadAsZip}
        setDocDetails={setDocDetails}
      />
    </>
  )
}

export default RolesTable
